// src/auth/RequireFaskesAuth.jsx
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  extractRole,
  getFaskesSession,
  isAllowedFaskesRole,
} from "./faskesSession";

/**
 * Guard tunggal untuk area Faskes/ICV.
 * Compatibility bridge icv.user dipindahkan ke effect supaya render tetap pure.
 */
export default function RequireFaskesAuth({ children }) {
  const location = useLocation();
  const { token, user } = getFaskesSession();
  const role = extractRole(user);
  const authed = Boolean(token) && isAllowedFaskesRole(role);

  useEffect(() => {
    if (!authed) return;

    try {
      const existing = sessionStorage.getItem("icv.user");
      if (existing) return;

      const username = user?.name || user?.email || "faskes";
      sessionStorage.setItem("icv.user", JSON.stringify({ username }));
    } catch {
      // Storage dapat ditolak browser; autentikasi utama tetap menggunakan token.
    }
  }, [authed, user?.name, user?.email]);

  if (!authed) {
    return (
      <Navigate
        to="/layanan-kerjasama-icv"
        replace
        state={{ from: location, reason: "auth" }}
      />
    );
  }

  return children;
}
